var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-card',{staticClass:"mb-4",attrs:{"loading":_vm.loading}},[_c('v-system-bar',[_vm._v("Untentschuldigte Absenzen")]),_c('AbsenceList',{attrs:{"items":_vm.absencesUnexcused,"hideStudent":"","schoolClass":_vm.student.schoolClass,"actions":['reactivate']},on:{"updated":_vm.updated}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }